import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6c378367"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "LiveMatchScore" }
const _hoisted_2 = /*#__PURE__*/_createTextVNode(" Back ")
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { id: "showLiveMatchScore" }
const _hoisted_5 = { class: "row" }
const _hoisted_6 = { class: "flex md5 playerNameCenter" }
const _hoisted_7 = { class: "scoreBoardHeadlinePlayerName" }
const _hoisted_8 = { class: "flex md2" }
const _hoisted_9 = { class: "scoreBoardHeadline" }
const _hoisted_10 = { class: "flex md5 playerNameCenter" }
const _hoisted_11 = { class: "scoreBoardHeadlinePlayerName" }
const _hoisted_12 = {
  class: "row",
  style: {"justify-content":"space-around"}
}
const _hoisted_13 = {
  class: "flex md5 mt-4",
  style: {"margin-top":"4px!important"}
}
const _hoisted_14 = { style: {"display":"inline-block","float":"left"} }
const _hoisted_15 = { style: {"float":"right"} }
const _hoisted_16 = { class: "pointRemaining pointRemainingReadOnly" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "flex md2 mt-4" }, [
  /*#__PURE__*/_createElementVNode("h3", { class: "arrowsUsedHeader" })
], -1))
const _hoisted_18 = {
  class: "flex md5 mt-4",
  style: {"margin-top":"4px!important"}
}
const _hoisted_19 = { style: {"display":"inline-block","float":"right"} }
const _hoisted_20 = { style: {"float":"left"} }
const _hoisted_21 = { class: "pointRemaining pointRemainingReadOnly" }
const _hoisted_22 = { class: "three-dart-avg-contains" }
const _hoisted_23 = { class: "three-dart-avg-text" }
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("h3", { class: "three-dart-avg-text" }, "3 Dart Avg")
], -1))
const _hoisted_25 = { class: "three-dart-avg-text" }
const _hoisted_26 = { class: "va-table-responsive scoreTable" }
const _hoisted_27 = {
  class: "va-table va-table--striped scores",
  style: {"width":"100%"},
  ref: "scoreTableView"
}
const _hoisted_28 = { class: "center" }
const _hoisted_29 = { key: 0 }
const _hoisted_30 = { key: 1 }
const _hoisted_31 = { class: "dartsthrown center" }
const _hoisted_32 = { class: "center" }
const _hoisted_33 = { key: 0 }
const _hoisted_34 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_va_button = _resolveComponent("va-button")!
  const _component_it_divider = _resolveComponent("it-divider")!
  const _component_va_chip = _resolveComponent("va-chip")!
  const _component_va_card = _resolveComponent("va-card")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_va_button, {
      class: "go-back-btn my-1 mx-2",
      icon: "arrow_back",
      "icon-color": "#ffffff50",
      color: "success",
      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.go(-1)))
    }, {
      default: _withCtx(() => [
        _hoisted_2
      ]),
      _: 1
    }),
    (_ctx.selectedMatchData)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("h2", _hoisted_7, _toDisplayString(_ctx.setPlayersNameFormate(_ctx.selectedMatchData.homePlayerName)), 1)
              ]),
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("h2", _hoisted_9, _toDisplayString(_ctx.selectedMatchData.homeTotalwins) + " - " + _toDisplayString(_ctx.selectedMatchData.awayTotalwins), 1)
              ]),
              _createElementVNode("div", _hoisted_10, [
                _createElementVNode("h2", _hoisted_11, _toDisplayString(_ctx.setPlayersNameFormate(_ctx.selectedMatchData.awayPlayerName)), 1)
              ]),
              _createVNode(_component_it_divider)
            ])
          ]),
          _createVNode(_component_va_card, {
            color: "#afcfff",
            stripe: "",
            "stripe-color": "#ab0033"
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_12, [
                _createElementVNode("div", _hoisted_13, [
                  _createElementVNode("span", _hoisted_14, [
                    _createElementVNode("span", _hoisted_15, [
                      _createVNode(_component_va_chip, {
                        class: "pointRemainingChip pointRemainingChipReadOnly",
                        color: (_ctx.isCurrentTurn ? '#fff' : '#ab0033'),
                        square: "",
                        readonly: ""
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("h3", _hoisted_16, _toDisplayString(_ctx.selectedMatchData.remainingHomePlayerScore), 1)
                        ]),
                        _: 1
                      }, 8, ["color"])
                    ])
                  ])
                ]),
                _hoisted_17,
                _createElementVNode("div", _hoisted_18, [
                  _createElementVNode("span", _hoisted_19, [
                    _createElementVNode("span", _hoisted_20, [
                      _createVNode(_component_va_chip, {
                        class: "pointRemainingChip pointRemainingChipReadOnly",
                        color: (!_ctx.isCurrentTurn ? '#fff' : '#ab0033'),
                        square: "",
                        readonly: ""
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("h3", _hoisted_21, _toDisplayString(_ctx.selectedMatchData.remainingAwayPlayerScore), 1)
                        ]),
                        _: 1
                      }, 8, ["color"])
                    ])
                  ])
                ])
              ]),
              _createVNode(_component_it_divider),
              _createElementVNode("div", _hoisted_22, [
                _createElementVNode("div", null, [
                  _createElementVNode("h3", _hoisted_23, _toDisplayString(_ctx.threeDartAvg(1)), 1)
                ]),
                _hoisted_24,
                _createElementVNode("div", null, [
                  _createElementVNode("h3", _hoisted_25, _toDisplayString(_ctx.threeDartAvg(0)), 1)
                ])
              ]),
              _createVNode(_component_it_divider),
              _createElementVNode("div", _hoisted_26, [
                _createElementVNode("table", _hoisted_27, [
                  _createElementVNode("tbody", null, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.sortTheMatchScoreOnPosition(_ctx.selectedMatchData.kamp_saet_scores), (matchSetScore, index) => {
                      return (_openBlock(), _createElementBlock("tr", { key: index }, [
                        _createElementVNode("td", _hoisted_28, [
                          (_ctx.checkForRoundPlayed(index, 1))
                            ? (_openBlock(), _createElementBlock("div", _hoisted_29, "---"))
                            : (_openBlock(), _createElementBlock("div", _hoisted_30, _toDisplayString(matchSetScore.homePlayerScore), 1))
                        ]),
                        _createElementVNode("td", _hoisted_31, _toDisplayString(matchSetScore.darts), 1),
                        _createElementVNode("td", _hoisted_32, [
                          (_ctx.checkForRoundPlayed(index, 0))
                            ? (_openBlock(), _createElementBlock("div", _hoisted_33, "---"))
                            : (_openBlock(), _createElementBlock("div", _hoisted_34, _toDisplayString(matchSetScore.awayPlayerScore), 1))
                        ])
                      ]))
                    }), 128))
                  ])
                ], 512)
              ])
            ]),
            _: 1
          })
        ]))
      : _createCommentVNode("", true)
  ]))
}